export default __webpack_public_path__ + "static/media/user-icon.bac1e441.svg";